<template>
  <div class="editBread">
    <a-breadcrumb>
      <a-breadcrumb-item>
        <router-link :to="{ path: '/PublicSet', query: queryParams }">
          公共功能配置
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        Topbar列表
      </a-breadcrumb-item>
    </a-breadcrumb>
    <a-button type="primary" @click="add">新增</a-button>
  </div>
  <div class="container">
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      bordered
    >
      <template #headerCell="{ column }">
        <template v-if="column.key === 'defaultFlag'">
          <span>默认TopBar</span>
          <a-popover>
            <template #content>
              <div style="width: 320px;">
                “默认Topbar”：兜底的Topbar，其状态不可编辑。
                <br />
                例：当有N个“启用状态”的Topbar时，则选取“默认Topbar”为“启用”的topbar对客呈现；
              </div>
            </template>
            <QuestionCircleOutlined style="color: #999;margin-left: 8px;" />
          </a-popover>
        </template>
        <template v-if="column.key === 'status'">
          <span>状态</span>
          <a-popover>
            <template #content>
              对客呈现的Topbar为：“启用”状态；
            </template>
            <QuestionCircleOutlined style="color: #999;margin-left: 8px;" />
          </a-popover>
        </template>
      </template>
      <template #bodyCell="{ column,record }">
        <template v-if="column.key === 'title'">
          <div style="maxWidth: 300px;">
            {{ record.title }}
          </div>
        </template>
        <template v-if="column.key === 'defaultFlag'">
          <a-switch
            :checked="record.defaultFlag"
            checkedChildren="启用"
            unCheckedChildren="禁用"
            :disabled="record.defaultFlag"
          />
        </template>
        <template v-if="column.key === 'status'">
          {{ record.status === 1 ? '启用' : '禁用' }}
        </template>
        <template v-if="column.key === 'deal'">
          <a-space>
            <a-button @click="editDrawerInfo(record)" type="link"
              >编辑</a-button
            >
            <template v-if="!record.canDelete">
              <a disabled>
                删除
              </a>
            </template>
            <a-popconfirm
              title="是否删除此topbar？"
              @confirm="remove(record.id)"
              ok-text="确认"
              cancel-text="取消"
              v-else
            >
              <a>删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </template>
    </a-table>
    <div class="cs-pagination">
      <div class="left">
        共 {{ pagination.total }} 条记录，第 {{ pagination.current }} /
        {{
          ~~(pagination.total / pagination.pageSize) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)
        }}
        页
      </div>
      <a-pagination
        v-model:current="pagination.current"
        v-model:pageSize="pagination.pageSize"
        show-quick-jumper
        show-size-changer
        :total="pagination.total"
        @change="onChange"
        :pageSizeOptions="pagination.pageSizeOptions"
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, computed } from 'vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import {
  config_query_top_bar,
  config_topbar_delete_post
} from '@/server/modules/topbar.js'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { cloneDeep, pick } from 'lodash-es'

export default {
  components: {
    QuestionCircleOutlined
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      queryParams: computed(() => {
        const result = cloneDeep(route?.query)
        return pick(result, ['terminalId', 'brandId', 'channelId', 'siteId'])
      }),
      dataSource: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '名称',
          dataIndex: 'title',
          key: 'title',
          width: 300
        },
        {
          title: '默认TopBar',
          dataIndex: 'defaultFlag',
          key: 'defaultFlag'
        },

        {
          title: '状态',
          dataIndex: 'status',
          key: 'status' //状态 -0.禁用、1.启用
        },
        {
          title: '更新人',
          dataIndex: 'modifier',
          key: 'modifier'
        },
        {
          title: '更新时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime'
        },
        {
          title: '操作',
          dataIndex: 'deal',
          key: 'deal'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40']
      },
      onShowSizeChange: (current, pageSize) => {
        state.pagination.pageSize = pageSize
        state.getTopBarList()
      },
      getTopBarList: () => {
        config_query_top_bar({
          pageSize: state.pagination.pageSize,
          pageNum: state.pagination.current,
          ...route?.query
        }).then(res => {
          state.dataSource = res.data?.list
          state.pagination.total = res.data?.total
        })
      },
      onChange: page => {
        state.pagination.current = page
        state.getTopBarList()
      },
      add: () => {
        router.push({
          path: 'PublicSetDetail',
          query: {
            type: 2, // topbar
            name: 'TopBar',
            ...route.query
          }
        })
      },
      editDrawerInfo: row => {
        router.push({
          path: 'PublicSetDetail',
          query: {
            id: row?.id,
            defaultFlag: row?.defaultFlag,
            type: 2, // topbar
            name: 'TopBar',
            ...route.query
          }
        })
      },
      remove: async id => {
        const res = await config_topbar_delete_post({ id })
        if (res.success) {
          state.getTopBarList()
        } else {
          message.error(res.retInfo)
        }
      }
    })

    onMounted(() => {
      state.getTopBarList()
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    color: #999;
  }
}
.add-content {
  background-color: #fff;
  padding: 12px 16px;
  margin-bottom: 24px;
  text-align: right;
}
.editBread {
  background: #ffffff;
  margin-bottom: 16px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container {
  padding: 24px;
  background-color: #ffffff;
}
</style>
